import api from "api";


const randomPicker = {
    get: (slug, page) => {
        return api().get(`/events/detail/${slug}/giveaways?page=${page}`) 
    },
    create: (slug, payload) => {
        return api().post(`/events/detail/${slug}/giveaways`, payload) 
    }
}

export default randomPicker;